<template>
  <section :class="$store.state.common.theme !=3 ? 'parking_mess' :'parking_mess parking_mess_theme_3'">
    <section class="parking_mess_left">
      <h2 @click="parkSelectFun">
        <span>{{parkingMess.parkName}}</span>
        <a-icon class="icon" v-if="parkList.length > 1" type="caret-down"></a-icon>
      </h2>
      <p >
        <img v-if="$store.state.common.theme !=3" src="../../../assets/images/parking/company.png" />
        <img v-else src="../../../assets/images/parking/company_3.png" />
        <span>{{common.userTenantInfo.company}}</span>
      </p>
    </section>
    <section class="parking_mess_right" v-if="parkingMess.h5ShowNumber == 1">
      <p>总车位<span>{{parkingMess.personalMonthlyNumber}}</span></p>
      <p>剩余车位<span>{{parkingMess.overplusPMonthlyNumber}}</span></p>
      <section class="bg_trigger"></section>
    </section>
    <mt-popup v-model="parkSelect" position="bottom" class="park_popup">
      <mt-picker class="picker" :slots="dataList" @change="onValuesChange" :visible-item-count="5" :show-toolbar="true" ref="picker" >
          <div class="picker_wrap">
            <div class="picker_btn" @click="parkSelect=false">取消</div>
            <div class="picker_btn2" @click="handleConfirm">确认</div>
          </div>
        </mt-picker>
    </mt-popup>
  </section>
</template>

<script>
import { mapState } from 'vuex';
export default {
  props:{
    parkingMess:{
      type:Object,
      default:()=>{}
    },
    applyData:{
      type:Object,
      default:()=>{}
    },
    parkList:{
      type:Array,
      default:()=>{[]}
    }
  },
  data(){
    return {
      companyName:'',
      parkSelect:false,
      dataList:[{
        flex: 1,
        values: [],
        className: 'slot1',
        textAlign: 'center'
      }],
    }
  },
  created(){
    // 有默认企业,且没有申请过,显示默认企业名称
    // if(this.$store.state.common.userTenantInfo.company && !this.applyData.id){
    //   this.companyName = this.$store.state.common.userTenantInfo.company
    // }
    // 有申请车位的公司名称显示申请时候的公司名称 移除2024-12-11
    // if(this.applyData.companyName){
    //   this.companyName = this.applyData.companyName;
    // }
    console.log(JSON.parse(JSON.stringify(this.parkingMess)), 'parkingMess');
    
  },
  methods:{
    parkSelectFun(){
      if(this.parkList.length <= 1){
        return;
      }
      this.parkSelect = true
      this.dataList[0].values = []
      this.parkList.forEach(item=>{
        this.dataList[0].values.push(item.parkName)
      })
    },
    onValuesChange (picker, values) {
      if (values[0] > values[1]) {
        picker.setSlotValue(1, values[0]);
      }
    },
    handleConfirm(){
       this.parkSelect = false
       var value = this.$refs.picker.getValues()[0];
       console.log(value)
       this.$emit('parkSelect',value)
    },
  },
  computed: {
    ...mapState({
      common: state => state.common
    })
  },
};
</script>

<style lang="less" scoped>
@import "../../../assets/css/common.less";
.parking_mess {
  width: 100%;
  height: 186px;
  background: rgba(23, 64, 218, 1) url('../../../assets/images/park_bg.jpg') left top no-repeat;
  background-size:100% 100%;
  .flex();
  flex-wrap:nowrap;
  justify-content: space-between;
  .parking_mess_left {
    flex: 1;
    padding-left:28px;
    overflow:hidden;
    h2 {
      height: 50px;
      font-size: 36px;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
      line-height: 50px;
      margin: 40px 0 22px;
      .flex();
      flex-wrap: nowrap;
      align-items: center;
      span{
        .textOver(100%);
      }
      .icon{
        margin-left:4px;
        font-size:32px;
        margin-top:10px;
        font-weight: bold;
      }
    }
    p {
      .flex();
      align-items: center;
      height:34px;
      overflow: hidden;
      align-items: center;
      img{
        display:block;
        width:34px;
        height:34px;
        margin-right:16px;
      }
      span{
        flex:1;
        .textOver(100%);
        font-size: 28px;
        color: rgba(255, 255, 255, 1);
        line-height: 34px;
      }
    }
  }
  .parking_mess_right{
    position: relative;
    padding-right:28px;
    // min-width:220px;
    .flex(column);
    justify-content: center;
    align-items: flex-end;
    padding-left:40px;
    height: 186px;
    overflow: hidden;
    white-space: nowrap;
    flex-shrink: 0;
    p{
      margin:11px 0;
      font-size:24px;
      color:rgba(255,255,255,1);
      line-height:34px;
      span{
        margin-left:10px;
        display:inline-block;
        font-size:32px;
        font-weight:bold;
        color:rgba(255,255,255,1);
        line-height:44px;
      }
    }
    .bg_trigger{
      display: none;
      width:30px;
      height:186px;
      background:rgba(23, 64, 218, 1);
      position:absolute;
      top:0;left:0;
      transform: rotate(10deg) translate(-10px);
    }
  }
}
.parking_mess_theme_3{
  background: #A1805D;
}
</style>
